/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserModel {
    getFixupPrototypeFunction() { return UserModel.fixupPrototype; }

    static newInstance(model: Partial<UserModel>): UserModel {
        let obj = Object.assign(new UserModel(), model);
        UserModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserModel>): UserModel {
        if (!model) return null;
        return UserModel.newInstance(<UserModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserModel) {
        if (!obj) return;

        models.UserModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserModel): boolean {
        Object.setPrototypeOf(obj, UserModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.timezone) {
            models.TimezoneModel.fixupPrototype(this.timezone);
        }
    }

    /**
     * Name of the user.
     */
    name: string;

    /**
     * Id of the user. This will be used for performing user level operations such as getUser, changePassword and so on.
     */
    id: string;

    /**
     * Email Id of the user. This wil be unique.
     */
    email: string;

    /**
     * Active tenant id.
     */
    active_tenant_id: string;

    /**
     * Contains information about the timezone set for the user.
     */
    timezone: models.TimezoneModel;

    /**
     * Preferred language of the user.
     */
    preferred_language: models.PreferredLanguage;

    /**
     * Preferred UI theme of the user, such as light or dark. Empty when the user has not chosen one.
     */
    preferred_theme: string;

    /**
     * Checks if the account is mcp server enabled or not
     */
    mcp_server_enabled: boolean;

    /**
     * Checks if the account is graphdb sync enabled enabled or not
     */
    graphdb_sync_enabled: boolean = false;

    /**
     * Checks if the account is mfa enabled or not
     */
    mfa_enabled: string;

    /**
     * Master Account ID of the user.
     */
    master_account_id: string;

    /**
     * Master Account Name of the user.
     */
    master_account_name: string;

    /**
     * Products enabled in the master account
     */
    products: Array<string>;

    /**
     * Customer Relationship Management ID
     */
    crm_id: string;

    /**
     * list of master account ids
     */
    master_account_ids: Array<string>;

}
